module.exports = __webpack_public_path__ + "static/media/03.e1aa95bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/boulders/03.jpg
// module id = 462
// module chunks = 0